import React from 'react';

type VirtualHorizontalExpanderProps = {
    virtualWidth: number;
};

export const VirtualHorizontalExpander = (props: VirtualHorizontalExpanderProps) => {
    return <div className="virtual-list-hwrapper" style={{ width: props.virtualWidth }} />;
};
